import { FIELD_TYPES } from "../shared/constants";

const { TEXT_FIELD, SELECT_FIELD, SELECT_DATE_FIELD } = FIELD_TYPES;

export const FILTER_OPTIONS = [
  {
    Name: "Address",
    ObjectId: `Address/${TEXT_FIELD}`
  },
  {
    Name: "City",
    ObjectId: `AddressCity/${TEXT_FIELD}`
  },
  {
    Name: "County",
    ObjectId: `AddressCounty/${TEXT_FIELD}`
  },
  {
    Name: "Post Code",
    ObjectId: `AddressPostCode/${TEXT_FIELD}`
  },
  {
    Name: "Phone Number",
    ObjectId: `PhoneNumber/${TEXT_FIELD}`
  },
  {
    Name: "Email",
    ObjectId: `Email/${TEXT_FIELD}`
  },
  {
    Name: "Client Induction",
    ObjectId: `ClientInduction/${SELECT_DATE_FIELD}`
  },
  {
    Name: "Identification",
    ObjectId: `Identification/${SELECT_DATE_FIELD}`
  },
  {
    Name: "Qualification",
    ObjectId: `Qualification/${SELECT_DATE_FIELD}`
  },
  {
    Name: "Driving Licence Capability",
    ObjectId: `DrivingLicenceCapability/${SELECT_DATE_FIELD}`
  },
  {
    Name: "Not Client Banned",
    ObjectId: `NotClientBanned/${SELECT_FIELD}`
  },
  {
    Name: "Worked At Sites",
    ObjectId: `WorkedAtSites/${SELECT_FIELD}`
  },
  {
    Name: "Status",
    ObjectId: `Status/${SELECT_FIELD}`
  },
  {
    Name: "Tags",
    ObjectId: `Tags/${SELECT_FIELD}`
  },
  {
    Name: "Site Of Interest",
    ObjectId: `SiteOfInterest/${SELECT_FIELD}`
  },
  {
    Name: "Duplicate Contacts",
    ObjectId: `DuplicateContacts/${SELECT_FIELD}`
  },
  {
    Name: "STS",
    ObjectId: `STS/${SELECT_FIELD}`
  }
];
